module.exports = "/static/assets/7f848e761c790803ece92402ddc4a8d7.gif";